import React from 'react'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import PropTypes from 'prop-types'
import './AutoComplete.scss'
import { debounce } from '@engine/utils/jsUtils'

function AutoComplete(props) {
  const onTextChangeHandler = value => {
    if (value && value.length > 2) {
      props.onTextChangeHandler({ data: value })
    }
  }

  const debouncedChange = debounce(onTextChangeHandler, 250)

  return (
    <Autocomplete
      id={props.name}
      data-testid={props.name}
      options={props.displayOptions}
      getOptionLabel={props.getOptionLabel}
      getOptionSelected={props.getOptionSelected}
      onChange={(e, newValue) => props.onSelectedHandler(newValue)}
      value={props.value}
      renderInput={params =>
        <TextField
          variant="outlined"
          margin="dense"
          name={props.name}
          type="text"
          fullWidth
          InputProps={{ 'data-testid': props.name }}
          onChange={e => debouncedChange(e.target.value)}
          {...params}
        />
      }
    />
  )
}

AutoComplete.propTypes = {
  onTextChangeHandler: PropTypes.func,
  displayOptions: PropTypes.array,
  getOptionLabel: PropTypes.func,
  name: PropTypes.string,
  onSelectedHandler: PropTypes.func,
  getOptionSelected: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}

export default AutoComplete
